import { render } from "./CollaborationPlansHistory.vue?vue&type=template&id=45987e68"
import script from "./CollaborationPlansHistory.vue?vue&type=script&lang=js"
export * from "./CollaborationPlansHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__